module.exports = __webpack_public_path__ + "static/media/logo.02c8b7f0.png";